import { createReducer, on } from '@ngrx/store';
import * as PlantActions from '../../actions/master-data/plant.actions';
import { PlantState } from '../../states/master-data/plant.state';

export const initialState: PlantState = {loading: false, plants: [], error: undefined, successMessage: ''};

export const plantReducer = createReducer(
    initialState,
    on(PlantActions.loadPlants, (state) => ({ ...state, loading: true, error: null, successMessage: '' })),
    on(PlantActions.loadPlantsSuccess, (state, {plants}) => ({ ...state, loading: false, plants })),
    on(PlantActions.addPlant, (state, {plant}) => ({...state, plants: [...state.plants, plant]})),
    on(PlantActions.addPlantSuccess, (state, { message }) => ({
        ...state,
        successMessage: message,
        error: null
      })),
    on(PlantActions.updatePlant, (state, {plant}) => ({...state, plants: state.plants.map(r => r.id === plant.id ? plant : r)})),
    on(PlantActions.updatePlantSuccess, (state, { message }) => ({
      ...state,
      successMessage: message ?? 'Plant updated successfully',
      error: null
    })),
    on(PlantActions.deletePlant, (state, {id}) => ({...state, plants: state.plants.filter(r => r.id !== id)})),
    on(PlantActions.deletePlantSuccess, (state, { message }) => ({
      ...state,
      successMessage: message ?? 'Plant deleted successfully',})),
    on(PlantActions.loadPlantsFailure, (state, { error }) => ({ ...state, loading: false, error })),
);